import { render, staticRenderFns } from "./PartnerPackRestriction.vue?vue&type=template&id=68b87ad2&scoped=true"
import script from "./PartnerPackRestriction.vue?vue&type=script&lang=ts"
export * from "./PartnerPackRestriction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b87ad2",
  null
  
)

export default component.exports